import {
    createSlice,
    current
} from '@reduxjs/toolkit';
import {
    getPositionList,
    addNewPosition,
    updatePosition,
    deletePosition,
    getPosition,
} from '../position/thunk';

export const initialState = {
    itemPositionList: [],
    itemPositionDetail: null,
    isPositionLoading: false,
    isPositionSuccess: false,

    PositionList: [],
    PositionListSelect: [],
    isLoadingList: false,
    isAdding: false,
    isAdded: false,
    isAddError: false,
    isUpdating: false,
    isUpdated: false,
    isUpdateError: false,
    isDeleting: false,
    isDeleted: false,
    isDeleteError: false,
    requireCloseModal: false,
};

const PositionSlice = createSlice({
    name: 'Positions',
    initialState,
    reducers: {
        setRequireCloseModal(state, action) {
            state.requireCloseModal = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getPosition.fulfilled, (state, action) => {
            state.isPositionLoading = false;
            state.isPositionSuccess = true;
            state.itemPositionDetail = action.payload;
            state.isLoadingList = false;
        });
        builder.addCase(getPosition.pending, state => {
            state.isPositionLoading = true;
            state.isPositionSuccess = null;
            state.error = null;
            state.isLoadingList = true;
        });
        builder.addCase(getPosition.rejected, (state, action) => {
            state.isPositionLoading = false;
            state.isPositionSuccess = false;
            state.error = action.error.message;
            state.isLoadingList = false;
        });

        builder.addCase(getPositionList.pending, state => {
            state.isPositionSuccess = true;
            state.error = null;
            state.isLoadingList = true;
        });
        builder.addCase(getPositionList.fulfilled, (state, action) => {
            state.itemPositionList = action.payload;
            state.PositionList = action.payload;
            state.isLoadingList = false;
            state.isPositionSuccess = true;

            let PositionListSelect = [];
            action.payload.map(item =>
                PositionListSelect.push({
                    item: item,
                    value: item._id,
                    label: item.name,
                })
            );

            state.PositionListSelect = PositionListSelect;
        });
        builder.addCase(getPositionList.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isPositionSuccess = true;
        });

        
        builder.addCase(addNewPosition.fulfilled, (state, action) => {
            state.itemPositionList.push(action.payload);
            state.PositionList.push(action.payload);
            state.isLoadingList = false;
            state.isAdding = false;
            state.isAdded = true;
            state.isAddError = false;
            state.requireCloseModal = true;
        });
        builder.addCase(addNewPosition.pending, (state, action) => {
            state.isLoadingList = true;
            state.isAdding = true;
            state.isAdded = false;
            state.isAddError = false;
        });
        builder.addCase(addNewPosition.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isAdding = false;
            state.isAdded = false;
            state.isAddError = true;
        });


        builder.addCase(updatePosition.fulfilled, (state, action) => {
            state.itemPositionList = state.itemPositionList.map(Position =>
                Position.Positionname === action.payload.old_Position
                    ? { ...Position, ...action.payload.updated_Position }
                    : Position
            );
            state.PositionList = state.PositionList.map(Position =>
                Position._id.toString() === action.payload._id.toString()
                    ? { ...Position, ...action.payload }
                    : Position
            );
            state.isLoadingList = false;
            state.isUpdating = false;
            state.isUpdated = true;
            state.isUpdateError = false;
            state.requireCloseModal = true;
        });
        builder.addCase(updatePosition.pending, state => {
            state.isLoadingList = true;
            state.isUpdating = true;
            state.isUpdated = false;
            state.isUpdateError = false;
        });
        builder.addCase(updatePosition.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isUpdating = false;
            state.isUpdated = false;
            state.isUpdateError = true;
        });

        builder.addCase(deletePosition.fulfilled, (state, action) => {
            state.itemPositionList = current(state.itemPositionList).filter(
                item => item._id !== action.payload._id
            );
            state.PositionList = current(state.PositionList).filter(item =>
                item._id !== action.payload._id
            );
            state.isLoadingList = false;
            state.isDeleting = false;
            state.isDeleted = true;
            state.isDelete = false;
            state.requireCloseModal = true;
        });
        builder.addCase(deletePosition.pending, (state, action) => {
            state.isLoadingList = true;
            state.isDeleting = false;
            state.isDeleted = true;
            state.isDelete = false;
        });
        builder.addCase(deletePosition.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isDeleting = false;
            state.isDeleted = false;
            state.isDelete = true;
        });
    },
});

export const { setRequireCloseModal } = PositionSlice.actions;

export default PositionSlice.reducer;